import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LOCAL_STORAGE_KEYS } from '../models/local-storage-keys';

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  private readonly EXTERNAL_URL = 'external';
  constructor() { }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN);

    if (token && this.isApiRequest(request)) {
      const cloned = request.clone({
        headers: request.headers.set('Authorization', 'Bearer ' + token),
        url: this.createExternalUrl(request.url),
      });
      return next.handle(cloned);
    } else {
      return next.handle(request);
    }
  }

  private createExternalUrl(url: string): string {
    return `${url.slice(0, environment.apiUrl.length)}external/${url.slice(
      environment.apiUrl.length
    )}`;
  }

  private isApiRequest(request: HttpRequest<unknown>): boolean {
    return request.url.includes(environment.apiUrl);
  }
}
